import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CLIPBOARD_SERVICE_TOKEN = new InjectionToken<IClipboardService>('IClipboardService');

export interface IClipboardService {
  copyFromContent(content: string): void;
  getContent(): Observable<string>;
}
